module.exports = __webpack_public_path__ + "static/media/cash-for-old-cars.9657e5a1.png";